import React from "react";
import Aboutpolicy from '../components/Aboutus/Aboutpolicy';
import Banner from '../comman/Banner/Banner';


const Aboutquality = () => {
  return (
    <>
      <Banner
        index={'about-6'}
      />
      <Aboutpolicy />
    </>

  )
};

export default Aboutquality;